import { render, staticRenderFns } from "./AgentPage.vue?vue&type=template&id=96fd6410"
import script from "./AgentPage.vue?vue&type=script&lang=js"
export * from "./AgentPage.vue?vue&type=script&lang=js"
import style0 from "./AgentPage.vue?vue&type=style&index=0&id=96fd6410&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports